import { FORMAT_LABELS } from './uploadFormat';
import type { ExtractionResult } from './uploadTypes';

/**
 * The counts, with "cannot identify" kept distinct from "none found".
 *
 * Exported for its own test: the difference between a null and a zero here is
 * the difference between an honest gap and a false claim.
 */
export function statsOf(result: ExtractionResult) {
  const translatable = result.passages.filter((p) => p.type !== 'quran').length;

  const quotation = (count: number | null, what: string) => {
    if (count === null) {
      return { value: '—', sub: 'cannot identify' };
    }
    return {
      value: String(count),
      sub: count === 0 ? `none identified` : `identified by ${what}`,
    };
  };

  const quran = quotation(result.quran, 'font');
  const hadith = quotation(result.hadith, 'framing');

  return [
    {
      label: 'Format detected',
      value: FORMAT_LABELS[result.format],
      sub: result.formatNote ?? 'read from the file’s bytes',
    },
    {
      label: 'Passages',
      value: String(result.passages.length),
      sub: `${translatable} translatable`,
    },
    { label: 'Qur’an quotations', ...quran },
    { label: 'Hadith quotations', ...hadith },
  ];
}
